import DashboardPage from '@/pages/DashboardPage.vue';
import { buildEntityListRoutes, buildEntityRecordRoutes } from '@/router/entityRoutes';
import EditPage from '@/pages/Profile/EditPage.vue';
import SidebarLayout from '@/layouts/SidebarLayout.vue';
import TrackMatchingPage from '@/pages/TrackMatchingPage.vue';
import PermissionsPage from '@/pages/PermissionsPage.vue';
import DynamoDbTableStatsPage from '@/pages/DynamoDbTableStatsPage.vue';
import AudioFileIssuesPage from '@/pages/AudioFileIssuesPage.vue';
import AudioFileIssueInspectorPage from '@/pages/AudioFileIssueInspectorPage.vue';
import PlaylistSwitchingPage from '@/pages/PlaylistSwitchingPage.vue';
import ImportSavedViewPage from '@/pages/ImportSavedViewPage.vue';
import DdexConfigurationsPage from '@/pages/DdexConfigurationsPage.vue';

const routes = [
  {
    path: '/',
    component: SidebarLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'home',
        component: DashboardPage
      },
      ...buildEntityListRoutes(),
      ...buildEntityRecordRoutes(),
      {
        // The full search page (SAU-437 follow-ups). Cmd+K is the quick modal.
        path: 'search',
        name: 'search',
        component: () => import('@/pages/SearchPage.vue'),
      },
      {
        path: 'track-matching',
        name: 'track-matching',
        component: TrackMatchingPage
      },
      {
        path: 'profile',
        name: 'profile',
        component: EditPage
      },
      {
        path: 'permissions',
        name: 'permissions',
        component: PermissionsPage
      },
      {
        path: 'dynamo-table-stats',
        name: 'dynamo-table-stats',
        component: DynamoDbTableStatsPage,
      },
      {
        path: 'audio-file-issues',
        name: 'audio-file-issues',
        component: AudioFileIssuesPage,
      },
      {
        path: 'audio-file-issues/:code',
        name: 'audio-file-issues-detail',
        component: AudioFileIssueInspectorPage,
      },
      {
        path: 'reports/playlist-switching',
        name: 'playlist-switching',
        component: PlaylistSwitchingPage,
      },
      // Back-compat: the report lived at /reports/playlists before the
      // PlaylistSwitching rename — keep old bookmarks/links working.
      {
        path: 'reports/playlists',
        redirect: { name: 'playlist-switching' },
      },
      {
        path: 'ddex',
        name: 'ddex-configurations',
        component: DdexConfigurationsPage,
      },
      {
        // DDEX Configurations supersedes the standalone exclusions page; exclusions are now managed
        // per-sender inside a configuration. Keep old bookmarks/links working.
        path: 'ddex/party-exclusions',
        redirect: { name: 'ddex-configurations' },
      },
      {
        // Landing page for shared-view links. `?s=<shareKey>` names a published
        // view; the page resolves the key against the server, shows a
        // confirmation modal, and (on Import) creates the recipient's own
        // independent copy before navigating to that entity's table page.
        // A legacy `?d=` payload is recognised and refused — never decoded.
        path: 'views/import',
        name: 'import-saved-view',
        component: ImportSavedViewPage,
      },
    ]
  }
];

export default routes;
